import React from 'react'
import Avatar from 'components/profile/Avatar'
import styles from './styles/h2h.module.scss'
import { useTranslation } from 'react-i18next'
import { Player, VsInfo } from 'types/global'
import { TABLET_BREAKPOINT } from 'constants/global'
import useWindowSize from '../../hooks/use-windowSize'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'
import { getProfileUrl } from 'utils'
import { ClassNameProps } from 'types/utilities'

interface PlayerHeaderProps extends ClassNameProps {
  player: Player
  withLink: boolean
}
const PlayerHeader = ({ player, withLink, className }: PlayerHeaderProps) => {
  const { t } = useTranslation('strData')

  return (
    <div className={className}>
      <div className={styles.player}>
        <div className={styles.H2HAvatarWrapper}>
          <Avatar url={player.avatar} size='lg' />
        </div>
        {player.fullName ? (
          <h2 className={styles.headerName}>
            {withLink ? <a href={getProfileUrl(player.id)}>{player.fullName}</a> : player.fullName}
          </h2>
        ) : (
          t('noPlayerName')
        )}
      </div>
    </div>
  )
}

const H2HInfoHeader = ({ competedTotal, players, wins }: VsInfo) => {
  const loadedProfile = useSelector((state: AppState) => state.profile.loadedProfile)
  const [p1, p2] = players
  return (
    <section className={styles.players}>
      <PlayerHeader
        className={styles.playerOneAvatarWrapper}
        player={p1}
        withLink={!!p1?.id && p1.id !== loadedProfile?.id}
      />

      {competedTotal ? <VsOverall p1Wins={wins.p1} p2Wins={wins.p2} /> : <NotCompeted />}

      <PlayerHeader
        className={styles.playerTwoAvatarWrapper}
        player={p2}
        withLink={!!p2?.id && p2.id !== loadedProfile?.id}
      />
    </section>
  )
}

const NotCompeted = () => {
  const { t } = useTranslation('strMatchHistory')

  return <p className={styles.H2HInfoHeaderNotCompeted}>{t('notCompeted')}</p>
}

interface VsOverallProps {
  p1Wins: number
  p2Wins: number
}

const VsOverall = ({ p1Wins, p2Wins }: VsOverallProps) => {
  const { t } = useTranslation('strH2H')
  const windowWidth = useWindowSize().width

  if (windowWidth && windowWidth > TABLET_BREAKPOINT) {
    return (
      <div className={styles.winsVsWinsWrapper}>
        <div className={styles.winsP1}>
          <span className={styles.winsNum}>{p1Wins}</span>
          <span className={styles.winPercent}>{t('wins', { count: p1Wins })}</span>
        </div>
        <span className={styles.versus}>vs</span>
        <div className={styles.winsP2}>
          <span className={styles.winsNum}>{p2Wins}</span>
          <span className={styles.winPercent}>{t('wins', { count: p2Wins })}</span>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.winsVsWinsWrapper}>
      <span className={styles.versus}>vs</span>
    </div>
  )
}

export default H2HInfoHeader
